import { useQuery } from '@tanstack/react-query'
import {
  FillRateByNoticeTimeseries,
  getFillRateByNoticeTimeseries,
} from 'api/pulse/fillRateByNoticeTimeseries'
import { PulseFilters } from 'api/pulse'
import { getFillRateByNoticeTimeseriesKey } from './keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useFillRateByNoticeTimeseries(query: PulseFilters) {
  return useQuery<FillRateByNoticeTimeseries>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getFillRateByNoticeTimeseriesKey(query),
    queryFn: ({ signal }) => getFillRateByNoticeTimeseries(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
